import { Reports } from '@/api/Reports';
import {
  DashboardTaskResponse,
  LocationCounts,
  ReportResponse,
  TodoResponse,
} from '@/api/data-contracts';
import useUploadProgressService from '@/shared/api/uploadProgress.service';

const useReports = () => {
  const api = useUploadProgressService(Reports);

  const getActiveCampaigns = async (
    signal: AbortSignal | undefined,
  ): Promise<Record<string, number>> => {
    const { data } = await api.getLocationUserActiveCampaigns({ signal });
    return data;
  };

  const getActiveCampaignsWithCounts = async (
    signal: AbortSignal | undefined,
  ): Promise<Record<string, LocationCounts>> => {
    const { data } = await api.getLocationUserActiveCampaignsWithCounts({ signal });
    return data;
  };

  const getActiveCampaignsWithCountsById = async (
    locationId: string,
    signal?: AbortSignal,
  ): Promise<LocationCounts> => {
    const { data } = await api.getLocationUserActiveCampaignsWithCountsByLocation(
      locationId,
      signal,
    );
    return data;
  };

  const getLocationReport = async (
    locationId: string,
    query: {
      topXClients: number;
    },
    signal?: AbortSignal | undefined,
  ): Promise<ReportResponse> => {
    const { data } = await api.getLocationReport(locationId, query, { signal });

    return data;
  };

  const getLocationTodos = async (
    locationId: string,
    signal?: AbortSignal | undefined,
  ): Promise<TodoResponse[]> => {
    const { data } = await api.getLocationTodos(locationId, { signal });

    return data;
  };

  const getLocationTodosAndTasks = async (
    locationId: string,
    signal?: AbortSignal | undefined,
  ): Promise<DashboardTaskResponse> => {
    const { data } = await api.getLocationTodosAndTasks(locationId, { signal });

    return data;
  };

  return {
    getActiveCampaignsWithCountsById,
    getActiveCampaignsWithCounts,
    getActiveCampaigns,
    getLocationReport,
    getLocationTodos,
    getLocationTodosAndTasks,
  };
};

export default useReports;
